import candidate from './candidate'
import chartReport from './chartReport'
import chatBot from './chatBot'
import client from './client'
import company from './company'
import interview from './interview'
import jobList from './jobList'
import layout from './layout'
import referral from './referral'
import talent from './talent'
import crm from './crm'
import job from './job'
import questionnaire from './questionnaire'
import application from './application'
import openQuestion from './openQuestion'
import hrDashboard from './hrDashboard'
import addCandidate from './application/candidate'
import rpa from './rpa'
import customer from './customer'
import apScheduler from './apScheduler'
import notification from './notification'
import openApi from './openApi'
import companyCulture from './companyCulture'
import resetPassword from './resetPassword'

export default {
  candidate,
  addCandidate,
  chartReport,
  chatBot,
  client,
  company,
  interview,
  jobList,
  layout,
  referral,
  talent,
  crm,
  job,
  questionnaire,
  application,
  openQuestion,
  hrDashboard,
  rpa,
  customer,
  apScheduler,
  notification,
  openApi,
  companyCulture,
  resetPassword
}
